/**
 * The Math — Calculator JS for torque.coffee/pages/the-math
 * Vanilla JS, no dependencies.
 * Handles: Check Our Math (live product data) and Check Anyone's Math (universal calculator)
 */

(function () {
  'use strict';

  /* =========================================================
   * CONSTANTS
   * Green weight factor: how many lbs of green coffee
   * are needed per bag size, accounting for ~15% roast shrinkage.
   * green_lbs = roasted_oz / 16 / 0.85
   * ========================================================= */
  var SHRINKAGE = 0.85;
  var BAG_SIZES = {
    '12 oz':  { oz: 12, label: '12 oz',  green_lbs: (12 / 16) / SHRINKAGE },
    '2 lb':   { oz: 32, label: '2 lb',   green_lbs: (32 / 16) / SHRINKAGE },
    '5 lb':   { oz: 80, label: '5 lb',   green_lbs: (80 / 16) / SHRINKAGE },
    '12oz':   { oz: 12, label: '12 oz',  green_lbs: (12 / 16) / SHRINKAGE },
    '2lb':    { oz: 32, label: '2 lb',   green_lbs: (32 / 16) / SHRINKAGE },
    '5lb':    { oz: 80, label: '5 lb',   green_lbs: (80 / 16) / SHRINKAGE }
  };

  var OZ_PER_GRAM = 1 / 28.3495;
  var OZ_PER_KG = 35.27396;

  /* =========================================================
   * UTILITY
   * ========================================================= */
  function fmt(n) {
    return '$' + Number(n).toFixed(2);
  }

  function pct(n) {
    return Number(n).toFixed(1) + '%';
  }

  function escHtml(s) {
    return String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function detectBagSize(variantTitle) {
    var t = variantTitle.toLowerCase().replace(/\s+/g, '');

    // Gram weights first (e.g. "250g coffee box"). Exclude kg so "1kg" isn't read as "1g".
    if (t.indexOf('kg') < 0) {
      var gramMatch = t.match(/(\d+)g\b/);
      if (gramMatch) {
        var grams = parseInt(gramMatch[1], 10);
        var gOz = grams * OZ_PER_GRAM;
        return { oz: gOz, label: grams + ' g', green_lbs: (gOz / 16) / SHRINKAGE };
      }
    }

    // Kilogram weights (e.g. "1kg")
    var kgMatch = t.match(/(\d+(?:\.\d+)?)kg\b/);
    if (kgMatch) {
      var kg = parseFloat(kgMatch[1]);
      var kOz = kg * OZ_PER_KG;
      return { oz: kOz, label: kg + ' kg', green_lbs: (kOz / 16) / SHRINKAGE };
    }

    if (t.indexOf('5lb') >= 0 || t.indexOf('5 lb') >= 0) return BAG_SIZES['5 lb'];
    if (t.indexOf('2lb') >= 0 || t.indexOf('2 lb') >= 0) return BAG_SIZES['2 lb'];
    if (t.indexOf('12oz') >= 0 || t.indexOf('12 oz') >= 0 || t.indexOf('340') >= 0) return BAG_SIZES['12 oz'];
    if (t.indexOf('retail') >= 0) return BAG_SIZES['12 oz'];
    if (t.indexOf('bulk') >= 0 && t.indexOf('5') >= 0) return BAG_SIZES['5 lb'];
    if (t.indexOf('bulk') >= 0 && t.indexOf('2') >= 0) return BAG_SIZES['2 lb'];
    return null;
  }

  /* =========================================================
   * CHECK OUR MATH
   * ========================================================= */
  var TheMathCheckOurs = {
    products: null,

    init: function () {
      var el = document.getElementById('the-math-products-data');
      if (!el) return;
      try {
        this.products = JSON.parse(el.textContent);
      } catch (e) {
        this.products = {};
      }
    },

    renderCard: function (handle, product) {
      var cardEl = document.getElementById('the-math-ours-card');
      if (!cardEl) return;

      var fob = parseFloat(product.fob_per_lb);
      var fobHtml = (fob && fob > 0)
        ? '<span class="the-math-coffee-card__fob">' + escHtml(fmt(fob) + '/lb Remains at Origin') + '</span>'
        : '';

      var flavorsHtml = '';
      if (product.flavors) {
        var parts = String(product.flavors).split(',');
        var cleaned = [];
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i].replace(/^\s+|\s+$/g, '');
          if (p) cleaned.push(escHtml(p));
        }
        if (cleaned.length) {
          flavorsHtml = '<p class="the-math-coffee-card__notes">' + cleaned.join(' &middot; ') + '</p>';
        }
      }

      var imgHtml = '';
      if (product.image) {
        imgHtml = '<img class="the-math-coffee-card__img" src="' + escHtml(product.image) +
          '" alt="' + escHtml(product.title) + '" loading="lazy">';
      }

      var url = product.url || '#';

      cardEl.innerHTML =
        '<a class="the-math-coffee-card" href="' + escHtml(url) + '">' +
          '<div class="the-math-coffee-card__media">' +
            imgHtml +
          '</div>' +
          '<div class="the-math-coffee-card__body">' +
            '<h3 class="the-math-coffee-card__title">' + escHtml(product.title) + '</h3>' +
            flavorsHtml +
            '<span class="the-math-coffee-card__action">' +
              '<span class="the-math-coffee-card__cta">Meet this coffee &rarr;</span>' +
              fobHtml +
            '</span>' +
          '</div>' +
        '</a>';
    },

    clearCard: function () {
      var cardEl = document.getElementById('the-math-ours-card');
      if (cardEl) cardEl.innerHTML = '';
    },

    onCoffeeChange: function (handle) {
      if (!this.products) this.init();
      var resultsEl = document.getElementById('the-math-ours-results');
      var calloutsEl = document.getElementById('the-math-ours-callouts');

      if (!handle || !this.products[handle]) {
        resultsEl.innerHTML = '<div class="the-math-empty">Select a coffee above to check the math.</div>';
        if (calloutsEl) calloutsEl.style.display = 'none';
        this.clearCard();
        return;
      }

      var product = this.products[handle];
      var fob = product.fob_per_lb;
      var cards = [];
      var variantCount = 0;
      var baselinePct = null;

      for (var i = 0; i < product.variants.length; i++) {
        var v = product.variants[i];
        var bag = detectBagSize(v.title);
        if (!bag) continue;

        var price = parseFloat(v.price);
        if (!price || price <= 0) continue;

        var originCost = fob * bag.green_lbs;
        var originPct = (originCost / price) * 100;

        if (baselinePct === null) baselinePct = originPct;
        var delta = originPct - baselinePct;

        variantCount++;

        var deltaHtml = '';
        if (delta > 0.05) {
          deltaHtml = '<div class="the-math-metric-delta">&#9650; +' + pct(delta) + '</div>';
        }

        cards.push(
          '<div class="the-math-card">' +
            '<div class="the-math-card-label">' + bag.label + ' bag</div>' +
            '<div class="the-math-metric">' +
              '<div class="the-math-metric-label">You pay</div>' +
              '<div class="the-math-metric-value">' + fmt(price) + '</div>' +
            '</div>' +
            '<div class="the-math-metric">' +
              '<div class="the-math-metric-label">Country of origin kept</div>' +
              '<div class="the-math-metric-value the-math-metric-value--highlight">' + fmt(originCost) + '</div>' +
            '</div>' +
            '<div class="the-math-metric the-math-metric-divider">' +
              '<div class="the-math-metric-label">That\'s</div>' +
              '<div class="the-math-metric-value the-math-metric-value--highlight">' + pct(originPct) + '</div>' +
              deltaHtml +
            '</div>' +
          '</div>'
        );
      }

      if (cards.length === 0) {
        resultsEl.innerHTML = '<div class="the-math-empty">No variant pricing data available for this coffee.</div>';
        if (calloutsEl) calloutsEl.style.display = 'none';
        // Still show the coffee card — FOB/image/title don't depend on variant parsing.
        this.renderCard(handle, product);
        return;
      }

      var gridClass = 'the-math-calculator-grid';
      if (variantCount === 2) gridClass += ' the-math-calculator-grid--two-col';
      if (variantCount === 1) gridClass += ' the-math-calculator-grid--one-col';

      resultsEl.innerHTML = '<div class="' + gridClass + '">' + cards.join('') + '</div>';

      this.renderCard(handle, product);

      if (calloutsEl) {
        calloutsEl.style.display = variantCount > 1 ? 'block' : 'none';
      }
    }
  };

  /* =========================================================
   * CHECK ANYONE'S MATH
   * ========================================================= */
  var TheMathCheckAnyones = {
    switchTab: function (tab) {
      var tabs = document.querySelectorAll('.the-math-tab');
      var panels = document.querySelectorAll('.the-math-tab-panel');

      for (var i = 0; i < tabs.length; i++) {
        tabs[i].classList.remove('the-math-tab--active');
        if (tabs[i].getAttribute('data-tab') === tab) {
          tabs[i].classList.add('the-math-tab--active');
        }
      }

      for (var j = 0; j < panels.length; j++) {
        panels[j].classList.remove('the-math-tab-panel--active');
      }

      var activePanel = document.getElementById('the-math-anyones-' + tab);
      if (activePanel) activePanel.classList.add('the-math-tab-panel--active');
    },

    calcConsumer: function () {
      var priceInput = document.getElementById('the-math-consumer-price');
      var sizeSelect = document.getElementById('the-math-consumer-size');
      var resultEl = document.getElementById('the-math-consumer-result');
      var shareEl = document.getElementById('the-math-consumer-share');
      var contextEl = document.getElementById('the-math-consumer-context');

      var price = parseFloat(priceInput.value);
      var bagOz = parseInt(sizeSelect.value, 10);

      if (!price || price <= 0) {
        resultEl.style.display = 'none';
        return;
      }

      var share = price * 0.20;
      var bagLabel = sizeSelect.options[sizeSelect.selectedIndex].text;

      shareEl.textContent = fmt(share);
      contextEl.textContent = fmt(share) + ' out of ' + fmt(price) + ' for a ' + bagLabel + ' bag';
      resultEl.style.display = 'block';
    },

    calcProducer: function () {
      var fobInput = document.getElementById('the-math-producer-fob');
      var sizeSelect = document.getElementById('the-math-producer-size');
      var resultEl = document.getElementById('the-math-producer-result');
      var retailEl = document.getElementById('the-math-producer-retail');
      var contextEl = document.getElementById('the-math-producer-context');

      var fob = parseFloat(fobInput.value);
      var bagOz = parseInt(sizeSelect.value, 10);

      if (!fob || fob <= 0) {
        resultEl.style.display = 'none';
        return;
      }

      var greenLbs = (bagOz / 16) / SHRINKAGE;
      var originCostPerBag = fob * greenLbs;
      var maxRetail = originCostPerBag / 0.20;
      var bagLabel = sizeSelect.options[sizeSelect.selectedIndex].text;

      retailEl.textContent = fmt(maxRetail);
      contextEl.textContent = 'FOB ' + fmt(fob) + '/lb \u00d7 ' + greenLbs.toFixed(3) + ' lbs green = ' + fmt(originCostPerBag) + ' origin cost. At 20%, max retail = ' + fmt(maxRetail);
      resultEl.style.display = 'block';
    }
  };

  /* =========================================================
   * EXPOSE TO GLOBAL SCOPE
   * (needed for inline onclick handlers in Liquid templates)
   * ========================================================= */
  window.TheMathCheckOurs = TheMathCheckOurs;
  window.TheMathCheckAnyones = TheMathCheckAnyones;

  /* =========================================================
   * INIT ON DOM READY
   * ========================================================= */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      TheMathCheckOurs.init();
    });
  } else {
    TheMathCheckOurs.init();
  }
})();
